import React from "react";
import "./MaterialCard.css";

interface MaterialCardProps {
  id: string;
  title: string;
  description: string;
  thumbnailUrl?: string;
  isFree?: boolean;
  onClick: () => void;
}

const MaterialCard: React.FC<MaterialCardProps> = ({
  title,
  description,
  thumbnailUrl,
  isFree,
  onClick,
}) => {
  const plainDescription = description
    .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, "")
    .replace(/<[^>]*>/g, "");

  return (
    <div className="material-card" onClick={onClick}>
      <div className="material-thumbnail">
        {thumbnailUrl ? (
          <>
            <img
              src={thumbnailUrl}
              alt={title}
              onError={(e) => {
                e.currentTarget.style.display = "none";
                const placeholder = e.currentTarget
                  .nextElementSibling as HTMLElement;
                if (placeholder) {
                  placeholder.style.display = "flex";
                }
              }}
            />
            <div
              className="thumbnail-placeholder"
              style={{ display: "none" }}
            >
              📚
              <small>Thumbnail indisponível</small>
            </div>
          </>
        ) : (
          <div className="thumbnail-placeholder">
            📚
            <small>Sem thumbnail</small>
          </div>
        )}
        {isFree && <div className="free-badge">GRATUITO</div>}
      </div>
      <div className="material-info">
        <h3 className="material-title">{title}</h3>
        <p className="material-description">{plainDescription}</p>
      </div>
    </div>
  );
};

export default MaterialCard;
